import { useEffect, useState } from 'react';

/**
 * This helper hooks returns last non-blank id.
 * Done to handle react re-render before marionette router route change, due to async code in the controllers
 * @param id - string that can be blank
 * @return string last non blank id
 */
export const useLastNonBlankId = (id: string): string => {
    const [currentNonBlankId, setCurrentNonBlankId] = useState(id);
    useEffect(() => {
        if (id) {
            setCurrentNonBlankId(id);
        }
    }, [setCurrentNonBlankId, id]);

    return currentNonBlankId;
};
